import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    formattedDate: string;
    order?: OrderModel;
}

type Props = OwnProps;

export interface ADIOrderDetailsSummaryTableMobileStyles {
    attributeTypeWrapper?: InjectableCss;
    attributeTypeLabelText?: TypographyPresentationProps;
    attributeTypeValuesText?: TypographyPresentationProps;
    attributeTypeLabelTextEven?: TypographyPresentationProps;
    attributeTypeValuesTextEven?: TypographyPresentationProps;
    firstSectionBoxMobile?: GridContainerProps;
    orderSummaryGridItem?: GridItemProps;
    orderSummaryText?: TypographyProps;
}

export const adiOrderDetailsSummaryTableMobileStyles: ADIOrderDetailsSummaryTableMobileStyles = {
    orderSummaryText: {
        variant: "h2",
        css: css`
            font-size: 22px;
            line-height: .64;
            margin-top: 5px;
            margin-bottom: 16px;
            color: ${ADIColors.darkBlue1};
            font-weight: bold;
        `
    },
    orderSummaryGridItem: {
        width: 12,
        css: css`
        flex-direction: column;
        `
    },
    firstSectionBoxMobile: {
        css: css`
        display: none;
        @media only screen and (max-width: 1024px) {
            display: block;
        }
        `,
    },
    attributeTypeLabelText: {
        css: css`
            word-break: break-word;
            background: ${ADIColors.white1};
        `,
    },
    attributeTypeValuesText: {
        css: css`
            background: ${ADIColors.white1};
            text-transform: capitalize;
        `,
    },
    attributeTypeLabelTextEven: {
        css: css`
            word-break: break-word;
            background: ${getColor("common.background")};
        `,
    },
    attributeTypeValuesTextEven: {
        css: css`
            background: ${getColor("common.background")};
            text-transform: capitalize;
        `,
    },
    attributeTypeWrapper: {
        css: css`
            width: 100%;
            display: grid;
            grid-template-columns: 35% 65%;
            border-radius: 6px;
            overflow: hidden;
            border: 1px solid ${ADIColors.gray3};
            >${TypographyStyle}{
                padding: 15px 12px;
                font-size: 14px;
                line-height: 14px;
                color: ${getColor("text.main")};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: 40% 60%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = adiOrderDetailsSummaryTableMobileStyles;

const ADIOrderDetailsSummaryTableMobile: FC<Props> = ({ formattedDate, order }) => {
    if (!order) {
        return null;
    }
    return (
        <GridContainer {...styles.firstSectionBoxMobile}>
            <GridItem {...styles.orderSummaryGridItem}>
                <Typography {...styles.orderSummaryText}>{translate("Order Summary")}</Typography>
                <StyledWrapper {...styles.attributeTypeWrapper}>
                    <Typography {...styles.attributeTypeLabelText}>{translate("Date")}</Typography>
                    <Typography {...styles.attributeTypeValuesText}>{formattedDate}</Typography>
                    <Typography {...styles.attributeTypeLabelTextEven}>{translate("PO #")}</Typography>
                    <Typography {...styles.attributeTypeValuesTextEven}>{order?.customerPO === "" ? translate("N/A") : order?.customerPO.toLowerCase()}</Typography>
                    <Typography {...styles.attributeTypeLabelText}>{translate("Reference #")}</Typography>
                    <Typography {...styles.attributeTypeValuesText}>{order?.orderRefNum === "" ? translate("N/A") : order?.orderRefNum?.toLowerCase()}</Typography>
                    <Typography {...styles.attributeTypeLabelTextEven}>{translate("Status")}</Typography>
                    <Typography {...styles.attributeTypeValuesTextEven}>{(order?.statusDisplay === "" && order?.invoiceOrderLines.length > 0) ? order?.invoiceOrderLines[0]?.suStatus.toLowerCase() : order?.statusDisplay.toLowerCase()}</Typography>
                    <Typography {...styles.attributeTypeLabelText}>{translate("Items")}</Typography>
                    <Typography {...styles.attributeTypeValuesText}>{order?.orderLines?.length}</Typography>
                    <Typography {...styles.attributeTypeLabelTextEven}>{translate("Total")}</Typography>
                    <Typography {...styles.attributeTypeValuesTextEven}>{order?.statusDisplay !== 'OPEN' ? order?.orderTotalDisplay : order?.productTotalDisplay}</Typography>
                </StyledWrapper>
            </GridItem>
        </GridContainer>

    )
};

export default ADIOrderDetailsSummaryTableMobile;
